import { observable, action, computed, makeObservable } from 'mobx'
import { RootStore } from '.'
import { VAULTURE_VIEW_LAYOUT_MODE } from '../utils/constants'
import { ViewLayoutType } from '../utils/models'

export class UIStore {
  layoutMode: ViewLayoutType = ViewLayoutType.TABLE
  showDropZone: number = 0

  private rootStore: RootStore

  constructor(rootStore: RootStore) {
    //@ts-ignore
    makeObservable(this, {
      layoutMode: observable,
      showDropZone: observable,
      isTableLayout: computed,
      isGridLayout: computed,
      loadDefaultLayout: action,
      changeLayout: action,
      dropZoneEnter: action,
      dropZoneDrop: action,
      dropZoneLeave: action
    })

    this.rootStore = rootStore
    this.loadDefaultLayout()

    window.onbeforeunload = () => {
      if (this.rootStore.fileStore.unfinishedUploads.length) {
        return (
          'Upload in progress, are you sure you want to close vaulture?' +
          'Uploads will be terminated'
        )
      } else {
        return
      }
    }
  }

  get isTableLayout() {
    return true//this.layoutMode === ViewLayoutType.TABLE
  }

  get isGridLayout() {
    return false//this.layoutMode === ViewLayoutType.GRID
  }

  loadDefaultLayout = () => {
    const layoutMode = localStorage.getItem(VAULTURE_VIEW_LAYOUT_MODE)
    this.layoutMode = layoutMode ? +layoutMode : ViewLayoutType.TABLE
  }

  changeLayout = (type: ViewLayoutType) => {
    this.layoutMode = type
    localStorage.setItem(VAULTURE_VIEW_LAYOUT_MODE, String(type))
  }

  dropZoneEnter = () => {
    this.showDropZone++
  }

  dropZoneDrop = () => {
    this.showDropZone = 0
  }

  dropZoneLeave = () => {
    this.showDropZone--
  }
}
